<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="languages">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs10 sm8 md6 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-3">
                        <v-toolbar-title>Idiomas&nbsp;&nbsp;</v-toolbar-title>
                        <v-text-field
                            :disabled="bEdit"
                            hide-details
                            single-line
                            v-model="searchText"
                            dense
                        ></v-text-field>
                        <v-btn :disabled="bEdit" small icon @click="onSearch">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                :disabled="bEdit"
                                text
                                class="text-none"
                                @click="onNewLanguage"
                            >Nuevo</v-btn>
                            <v-btn
                                :disabled="(bEdit || idiomaid === 0 )"
                                text
                                class="text-none"
                                @click="onEditLanguage"
                            >Editar</v-btn>
                            <v-btn
                                :disabled="(bEdit || idiomaid === 0 )"
                                text
                                class="text-none"
                                @click="onDeleteLanguage"
                            >Borrar</v-btn>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text :disabled="bEdit" @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-5">
                                <v-list-item :disabled="bEdit" @click="onNewLanguage">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">mdi-file-plus</v-icon>&nbsp; Nuevo Idioma
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onEditLanguage">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">mdi-pencil</v-icon>&nbsp; Editar Idioma
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onDeleteLanguage">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">mdi-delete</v-icon>&nbsp; Borrar Idioma
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>

                                <v-list-item :disabled="bEdit" @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de idiomas e idioma seleccionado: -->
                    <v-container pa-2 grid-list-md>
                        <!-- Renglón para lista de idiomas y card de idioma seleccionado: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Lista de Idiomas: *************************** -->
                            <v-flex xs10 sm4>
                                <v-card>
                                    <v-toolbar dense color="teal darken-1" dark flat>
                                        <v-toolbar-title class="my-list-title">Idiomas Registrados</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        :height="listHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        :disabled="bEdit"
                                        color="grey lighten-5"
                                    >
                                        <v-list-item-group
                                            v-model="selectedLanguageIndex"
                                            color="orange accent-4"
                                            :mandatory="!bNew"
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(language, i) in languages"
                                                :key="i"
                                                @click="selectLanguage(language.idiomaid)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex
                                                                    md2
                                                                    xs6
                                                                >{{ language.idioma }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina Lista de Idiomas ********************************* -->

                            <!-- Info de idioma seleccionado: *********************** -->
                            <v-flex xs10 sm8>
                                <v-card color="grey lighten-5">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >{{ selectedLanguageName }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-earth</v-icon>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        prepend-icon="mdi-earth"
                                                        name="idioma"
                                                        label="Idioma"
                                                        type="text"
                                                        v-model="idioma"
                                                        :readonly="!bEdit"
                                                        ref="name_field"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout
                                                v-if="bEdit"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSave"
                                                        :disabled="!bEdit"
                                                    >OK</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                        :disabled="!bEdit"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de idioma seleccionado *********************** -->
                        </v-layout>

                        <!-- Modal para confirmar borrado de idioma: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingLanguage" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar idioma</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar el idioma {{ selectedLanguageName }}?
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center"
                                    >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteLanguageConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteLanguage"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de idioma *************************** -->

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Búsqueda de Idiomas</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >No hay idiomas registrados con ese nombre.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que no hubo resultados en la búsqueda *************************** -->

                        <!-- Modal para informar que los datos del idioma no son válidos: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Información no Válida</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert-circle</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que los datos no son válidos *********************************** -->

                        <!-- Termina renglón para lista de idiomas e idioma seleccionado -->
                    </v-container>
                    <!-- Termina container para lista de idiomas e idioma seleccionado -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Languages',
    data() {
        return {
            drawer: false,
            bEdit: false,
            bNew: false,
            bInvalidData: false,
            errorMessage: '',

            idiomaid: 0,
            idioma: '',

            selectedLanguageName: '',
            bDeletingLanguage: false,

            searchText: '',
            bShowNotFoundAlert: false //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.
        };
    },
    components: {},
    created() {
        this.selectFirstLanguage();
    },
    methods: {
        onClose() {
            //console.log('Cerrando Languages.vue...');
            this.$router.push('/').catch(err => {});
        },
        onNewLanguage() {
            this.bEdit = true;
            this.bNew = true;
            this.selectedLanguageName = 'Nuevo Idioma';
            this.selectedLanguageIndex = -1;
            this.idiomaid = 0;
            this.idioma = '';

            this.$refs.name_field.focus();
        },
        onDeleteLanguage() {
            this.bDeletingLanguage = true;
        },
        cancelDeleteLanguage() {
            this.bDeletingLanguage = false;
        },
        deleteLanguageConfirmed() {
            this.bDeletingLanguage = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            var i;
            for (i = 0; i < this.languages.length; i++) {
                if (this.languages[i].idiomaid === this.idiomaid) {
                    this.languages.splice(i, 1);
                    break;
                }
            }

            this.$store.dispatch('deleteLanguage', this.idiomaid);
            this.selectFirstLanguage();
        },
        onEditLanguage() {
            this.bEdit = true;
        },
        onCancel() {
            if (this.bNew) {
                //Selecciona al primer usuario de la lista:
                this.selectFirstLanguage();
                this.bNew = false;
            } else {
                //Vuelve a obtener los datos originales del idioma seleccionado:
                this.selectLanguage(this.idiomaid);
            }
            this.bEdit = false;
        },
        onSave() {
            var bDataOK = false;

            //Se validan los datos:
            if (this.idioma === '') {
                this.bInvalidData = true;
                this.errorMessage = 'Teclee el idioma.';
            } else {
                bDataOK = true;
            }

            if (!this.bNew && bDataOK) {
                //Edición de idioma
                var i;
                for (i = 0; i < this.languages.length; i++) {
                    if (this.languages[i].idiomaid === this.idiomaid) {
                        this.languages[i].idioma = this.idioma;

                        //Actualiza el registro en la BD:
                        this.$store.dispatch(
                            'updateLanguage',
                            this.languages[i]
                        );

                        break;
                    }
                }
            } //end edición de idioma.
            else if (this.bNew && bDataOK) {
                //Registro de nuevo idioma...
                this.bNew = false;

                const newLanguage = {
                    idiomaid: 0,
                    idioma: this.idioma
                };

                this.$store.dispatch('saveNewLanguage', newLanguage);
            } //end registro de nuevo idioma.

            if (bDataOK) {
                this.selectedLanguageName = this.idioma;
                this.bEdit = false;
            }
        },
        selectFirstLanguage() {
            //console.log('this.languages = ', this.languages);
            //console.log('selectedLanguageIndex = ', this.selectedLanguageIndex);

            if (this.languages.length > 0) {
                this.selectedLanguageIndex = 0;
                var idiomaid = this.languages[this.selectedLanguageIndex]
                    .idiomaid;
                this.selectLanguage(idiomaid);
            } else {
                this.selectedLanguageIndex = -1;
                this.idiomaid = 0;
            }
        },
        selectLanguage(idiomaid) {
            var i;
            //console.log('selectLanguage, idiomaid = ', idiomaid);
            for (i = 0; i < this.languages.length; i++) {
                if (this.languages[i].idiomaid === idiomaid) {
                    console.log('Selected Language: ', this.languages[i]);

                    this.idiomaid = idiomaid;
                    this.idioma = this.languages[i].idioma;
                    this.selectedLanguageName = this.idioma;

                    break;
                }
            }
        },
        onSearch() {
            if (this.searchText != '') {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var i;
                var bFound = false;
                for (i = 0; i < this.languages.length; i++) {
                    var strLowerCaseText = this.languages[
                        i
                    ].idioma.toLowerCase();
                    if (strLowerCaseText.indexOf(searchTextLowerCase) === 0) {
                        this.selectedLanguageIndex = i;
                        this.selectLanguage(this.languages[i].idiomaid);
                        bFound = true;

                        // let container = document.getElementById(
                        //     this.languages[i].idiomaid
                        // );
                        // container.scrollToTop = 0;
                        break;
                    }
                }
                if (!bFound) {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        },
        onLogo() {
            this.bLogoUploadDlg = true;
        },
        onLogoUpload() {
            if (this.logoFile === null) {
                this.bShowNullLogoAlert = true;
            } else {
                this.bLogoUploadDlg = false;
                console.log('logoFile = ', this.logoFile);
            }
        },
        onCancelLogoUpload() {
            this.bLogoUploadDlg = false;
            this.logoFile = null;
        }
    },
    computed: {
        ...mapGetters(['languages', 'waitCursor']),
        selectedLanguageIndex: {
            get() {
                return this.$store.getters.selectedLanguageIndex;
            },
            set(selectedLanguageIndex) {
                this.$store.dispatch(
                    'updateSelectedLanguageIndex',
                    selectedLanguageIndex
                );
            }
        },

        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '100px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '200px';
            } else {
                height = '300px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '20%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '10%';
            }
            return width;
        },

        logoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '50';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '60';
            } else if (this.$vuetify.breakpoint.md) {
                height = '70';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '80';
            } else {
                height = '100';
            }
            return height;
        },

        logoButton() {
            var strText;
            if (this.logo === '') {
                strText = 'Agregar Logo';
            } else {
                strText = 'Cambiar Logo';
            }
            return strText;
        }
    }
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.6);
}
.languages {
    /* background: url('../assets/alex-kotliarskyi-QBpZGqEMsKg-unsplash.jpg'); */
    /*background: url('../assets/ben-rosett-WdJkXFQ4VHY-unsplash.jpg');*/
    background: url('../assets/hunters-race-MYbhN8KaaEc-unsplash.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>